import { render, staticRenderFns } from "./TrustSection.vue?vue&type=template&id=440502fc&scoped=true"
import script from "./TrustSection.vue?vue&type=script&lang=js"
export * from "./TrustSection.vue?vue&type=script&lang=js"
import style0 from "./TrustSection.vue?vue&type=style&index=0&id=440502fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440502fc",
  null
  
)

export default component.exports